// Local delivery only: both existing session transports feed the same presence UI.
export const SESSION_PRESENCE_CHANGED = 'pm:session-presence-changed';

export function sessionPresenceChanged(sessionId: unknown) {
  if (
    typeof sessionId === 'number' &&
    Number.isSafeInteger(sessionId) &&
    sessionId > 0
  )
    window.dispatchEvent(
      new CustomEvent(SESSION_PRESENCE_CHANGED, { detail: sessionId }),
    );
}
